class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.initVariables();
    this.addEventListeners();
    this.setHeaderCartIconAccessibility();
    this.customDrawerfun();
  }

  initVariables() {
    this.tmbCloseButton = null;
    this.tmbOverlay = null;
    this.popupbtn = null;
    this.compareDrawer = null;
    this.body = null;
    this.activeElement = null;
  }

  addEventListeners() {
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
  }

  customDrawerfun() {
    this.tmbCloseButton = document.querySelector(".tmb_closeButton");
    this.goBackButton = document.querySelector(".go_back");
    this.tmbOverlay = document.querySelector(".overlay_tmb");
    this.popupbtn = document.querySelector(".header__icons .cta-button");
    this.compareDrawer = document.querySelector(".products-comparison-section");
    this.body = document.querySelector("body");

    this.popupbtn?.addEventListener("click", (e) => {
      e.preventDefault();
      if (!this.popupbtn.classList.contains("header__icon")) {
        this.triggerCompareDrawer();
      }
    });

    const handleClose = () => {
      this.compareDrawer.classList.remove("active");
      this.tmbOverlay.classList.remove("active");
      this.compareDrawer.style.right = "-100%";
      this.body.classList.remove("overFlow");
    };

    this.tmbCloseButton?.addEventListener("click", handleClose);
    this.goBackButton?.addEventListener("click", handleClose);
    this.tmbOverlay?.addEventListener("click", handleClose);

    this.changeCustomCAT();
  }

  changeCustomCAT() {
    document.querySelectorAll("a").forEach((el) => {
      el.addEventListener("click", (e) => {
        let text = e.currentTarget.innerText.trim().toLowerCase();
        if (
          [
            "choose your device",
            "start hearing now",
            "order now & save",
            "get yours now",
            "grab this deal",
            "choose your hearing aid",
            "choose your soundbright",
            "click here to start hearing",
            "pick your soundbright",
            "get your mini now!",
            "get your discovery now!",
            "shop the mini",
            "shop the discovery",
            "take action now",
            "secure your mini",
            "secure your discovery",
            "get the mini",
            "get the discovery",
            "start saving now",
            "start hearing here",
          ].includes(text) &&
          !e.currentTarget.getAttribute("id")
        ) {
          e.preventDefault();
          this.triggerCompareDrawer();
        }
      });
    });
  }

  triggerCompareDrawer() {
    this.compareDrawer.classList.add("active");
    this.tmbOverlay.classList.add("active");
    this.compareDrawer.style.right = "0";
    this.body.classList.add("overFlow");
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink?.setAttribute("role", "button");
    cartLink?.setAttribute("aria-haspopup", "dialog");
    cartLink?.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");

    // Remove custom drawer
    this.compareDrawer?.classList.remove("active");
    this.tmbOverlay?.classList.remove("active");
    if (this.compareDrawer?.style) this.compareDrawer.style.right = "-100%";
    this.body?.classList?.remove("overFlow");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
